// const developmentApi = "http://localhost:5002/api/v1";
// const developmentApi = "http://192.168.193.45:5002/api/v1"; //with zerotier
const developmentApi = "http://127.0.0.1:8000/api/v1";
const productionApi = "https://api.dynamoedge.com/api/v1";

export default developmentApi;
